module.exports = __webpack_public_path__ + "static/8-de946ec40a12dd994ea53ec07af44cb3.png";